import React from "react";
import FooterImage1 from "../../assets/image1.png"; // Replace with actual images
import FooterImage2 from "../../assets/image2.png"; // Replace with actual images
import FooterImage3 from "../../assets/image3.png"; // Replace with actual images
import step1_0 from "../../assets/image.png";
import step1_1 from "../../assets/image (1).png";
import step1_2 from "../../assets/image (2).png";
import step1_3 from "../../assets/image (3).png";
import step1_4 from "../../assets/image (4).png";
import step1_5 from "../../assets/image (5).png";
import step1_6 from "../../assets/image (6).png";
import step1_7 from "../../assets/image (7).png";
import step1_8 from "../../assets/image (8).png";

import step2_1 from "../../assets/image (1) (1).png";
import step2_2 from "../../assets/image (2) (1).png";
import step2_3 from "../../assets/image (3) (1).png";
import step2_4 from "../../assets/image (4) (1).png";
import step2_5 from "../../assets/image (5) (1).png";
import step2_6 from "../../assets/image (6) (1).png";
import step2_7 from "../../assets/image (9).png";
import step2_8 from "../../assets/image (10).png";
import step2_9 from "../../assets/image (11).png";
import step2_10 from "../../assets/image (12).png";
import step2_11 from "../../assets/image (12) (1).png";

import step3_1 from "../../assets/image (13).png";
import step3_2 from "../../assets/image (14).png";
import step3_3 from "../../assets/step3_3.png";


import { useNavigate } from "react-router-dom";
import ZynthWorks, { Slide } from "../landing-page/ZynthWorks";
import { Theme } from "../../lib/theme";

const slides1: Slide[] = [
  {
    imageUrl: step1_0,
    dotPosition: { top: "39%", left: "33%" },
    caption: "1. Click on Text Box and Enter your presentation context.",
  },
  {
    imageUrl: step1_1,
    dotPosition: { top: "53%", left: "20%" },
    caption: "2. OR upload a document.",
  },
  {
    imageUrl: step1_2,
    dotPosition: { top: "65%", left: "51%" },
    caption: '3. Use the document dropdowns to customize your content further.',
  },
  {
    imageUrl: step1_3,
    dotPosition: { top: "90%", left: "50%" },
    caption: '4. Click "Submit" to view document options.',
  },
  {
    imageUrl: step1_4,
    dotPosition: { top: "30%", left: "20%" },
    caption: '5. Enter your "Reference Web URL".',
  },
  {
    imageUrl: step1_5,
    dotPosition: { top: "30%", left: "55%" },
    caption: "6. Enable the Web Search toggle to fetch information from the web.",
  },
  {
    imageUrl: step1_6,
    dotPosition: { top: "58%", left: "60%" },
    caption: '7. Select "Branding Colors" for the presentation.',
  },
  {
    imageUrl: step1_7,
    dotPosition: { top: "62%", left: "50%" },
    caption: '8. Adjust "Creativity" and "Technical Depth" based on your requirements.',
  },
  {
    imageUrl: step1_8,
    dotPosition: { top: "80%", left: "50%" },
    caption: '9. Click on "Generate Document".',
  },
];

const slides2: Slide[] = [
  {
  imageUrl: step2_1,
  dotPosition: { top: "40%", left: "70%" },
  caption: "1. View the generated document.",
  show: false,
},
{
  imageUrl: step2_2,
  dotPosition: { top: "50%", left: "11%" },
  caption: "2. Click “+” to add a new component.",
  show:false
},
{
  imageUrl: step2_3,
  dotPosition: { top: "52%", left: "10%" },
  caption: "3. Enter the Title, choose Section Type, and select a Generation Method.",
  show:false
},
{
  imageUrl: step2_4,
  dotPosition: { top: "20%", left: "95%" },
  caption: "4. Click the Edit button to modify content.",
},
{
  imageUrl: step2_5,
  dotPosition: { top: "75%", left: "75%" },
  caption: "5. Use the image search icon to refine your image.",
},
{
  imageUrl: step2_6,
  dotPosition: { top: "67%", left: "75%" },
  caption: "6. Search for an image and save the generated result.",
},
{
  imageUrl: step2_10,
  dotPosition: { top: "23%", left: "95%" },
  caption: "7. Select the wand icon to refine the text.",
},
{
  imageUrl: step2_7,
  dotPosition: { top: "65%", left: "75%" },
  caption: "8. Click the Refine Text button after rewriting.",
},
{
  imageUrl: step2_8,
  dotPosition: { top: "60%", left: "90%" },
  caption: "9. Click the ✓ (tick) button to approve changes.",
},
{
  imageUrl:step2_9 ,
  dotPosition: { top: "40%", left: "70%" },
  caption: "10. Set the tone and audience for your content.",
  show: false,
},
{
  imageUrl: step2_10,
  dotPosition: { top: "52%", left: "83%" },
  caption: "11. Save all changes after approval.",
  show:false
},
];

const slides3: Slide[] = [
  {
    imageUrl: step3_1,
    dotPosition: { top: "3%", left: "60%" },
    caption: '1. Click on "Export" dropdown to export the presentation.',
  },
  {
    imageUrl: step3_2,
    dotPosition: { top: "10%", left: "60%" },
    caption: `2. Select "Export as Word" to download.`,
    
  },
  // {
  //   imageUrl: step3_3,
  //   dotPosition: { top: "12%", left: "30%" },
  //   caption:
  //     '3. Make final changes on the downloaded Word File.',
  // },
  
];

const steps = [
  {
    number: 1,
    title: "Choose Input",
    description:
      "Start your document your way: type manually, upload a PDF/DOCX file, or select a topic prompt with optional web search to guide AI-powered drafting.",
    image: step1_1,
    slides: slides1,
  },
  {
    number: 2,
    title: "Refine & Format",
    description:
      "Apply grammar correction, adjust tone, style, and technical depth, or re-generate sections with the AI writing assistant for documents.",
    image: step2_1,
    slides: slides2,
  },
  {
    number: 3,
    title: "Export & Share",
    description:
      " Finalize your work with professional formatting and instantly download polished outputs in DOCX or PDF using our AI document generator.",
    image: step3_1,
    slides: slides3,
  },
];

const HowWorks: React.FC = () => {
  return (
    <div className="w-full bg-gradient-to-b from-[#f0f8f4] via-[#e5f3f1] to-[#ffffff] py-16 px-6 md:px-12">
      <div className="mb-10 max-w-7xl mx-auto px-4 md:px-0">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
         How It Works?
        </h2>
      </div>

      <div className="max-w-8xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        {steps.map((step) => (
          <div
            key={step.number}
            className="flex flex-col items-center text-center px-4"
          >
            {/* <img
              src={step.image}
              alt={`Step ${step.number}`}
              className="w-full h-auto rounded-lg shadow-md mb-6"
            /> */}
             <div className="flex-1 mb-6">
               <ZynthWorks slides={step.slides} bgColor="bg-[#3667B2]" />
              </div>
            <div className="flex items-center justify-center mb-2">
              <span className=" font-bold text-xl border  rounded-full w-8 h-8 flex items-center justify-center"
              style={{ color:Theme.colors.primary, borderColor:Theme.colors.primary }}
              >
                {step.number}
              </span>
            </div>
            <h3
              className={`text-xl font-bold mb-2 `}
              style={{
                color:Theme.colors.primary
              }}
            >
              {step.title}
            </h3>
            <p className="text-lg text-gray-700">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};



export default HowWorks;
